export abstract class AbstractDetectDeviceService {
  public abstract isMobilePhone: boolean;
  public abstract isTierTablet: boolean;
}
